import React, { useState } from 'react'
import { MdArrowBack } from 'react-icons/md'
import { useTranslation } from 'react-i18next'
import { request_new_password, verify_reset_token } from '../../server/server'
import LoginWrapper from './LoginWrapper'
import { useLocation, useHistory } from 'react-router-dom'
import { Oval } from 'react-loader-spinner'

function Token() {
    const [errorMessage, setErrorMessage] = useState('')
    const [token, setToken] = useState('')
    const { t } = useTranslation()
    const location = useLocation()
    const { email } = location.state || {}
    const history = useHistory()
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        const resp = await onTokenSubmit(email)
        if (resp.status !== 200) {
            setErrorMessage(resp.data)
            setLoading(false)
        } else {
            setLoading(false)
            history.push('/enter-new-password', { email, token: resp.data })
        }
    }

    const onTokenSubmit = async () => {
        try {
            const response = await verify_reset_token({ email, token })
            return response
        } catch (e) {
            return { data: 'Error', success: false }
        }
    }

    const repeatRequest = async () => {
        try {
            const response = await request_new_password({ email })
            return response
        } catch (e) {
            return { data: 'Error', success: false }
        }
    }

    return (
        <LoginWrapper>
            <div className="">
                <div className="modal-title">
                    <p className="modal-title-main-text">
                        <span
                            className="go-back-icon"
                            onClick={() => {
                                history.push('/new-password')
                            }}
                        >
                            <MdArrowBack />
                        </span>
                        {t('verifyYourEmail')}
                    </p>
                </div>
                <div className="modal-subtitle">
                    <p>{t('weHaveSentYouALinkToGetBackIntoYourAccountAndCheckYourMailAndCopyYourTokenHere')}</p>
                </div>

                <div className="sign-up-section">
                    <div className="login-form">
                        <form onSubmit={handleSubmit}>
                            <div className="login-form-element-holder">
                                <input className="login-form-input" placeholder="Token" value={token} onChange={(e) => setToken(e.target.value)} />
                            </div>
                            <div className="error-message">{t(errorMessage)}</div>
                            <div className="login-form-element-holder mt-20">
                                <button className="auth-form-button">
                                    {loading ? <Oval strokeWidth={5} secondaryColor="#7ec5c6" color="#7ec5c6" height={30} width={30} /> : t('submit')}
                                </button>
                            </div>
                        </form>
                    </div>
                    <div>
                        <p className="login-missing-text">
                            <span className="login-missing-text-q">{t('didntGetAMail')}</span>
                            <span className="login-missing-text-action" onClick={() => repeatRequest()}>
                                {t('resendARequest')}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </LoginWrapper>
    )
}

export default Token
